import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useLang } from "../LanguageContext";
import { Reveal, Overline, LineReveal } from "./Reveal";
import { optImg } from "../lib/img";

const Defense = () => {
  const { t, images } = useLang();
  const navigate = useNavigate();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgScale = useTransform(scrollYProgress, [0, 1], [1.18, 1]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);
  const d = t.defense || {};

  return (
    <section id="defense" ref={ref} className="relative bg-ink text-white overflow-hidden grain">
      <div className="absolute inset-0">
        <motion.img style={{ scale: imgScale, y: imgY }} src={optImg(images.defense, 1600)} alt="" loading="lazy" decoding="async"
          className="h-[115%] w-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-l from-ink via-ink/85 to-ink/40" />
      </div>

      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-10 py-28 md:py-44 flex justify-end">
        <div className="max-w-xl">
          <Reveal>
            <div className="flex items-center gap-3 mb-2 text-gold-light">
              <ShieldCheck size={20} strokeWidth={1.4} />
              <Overline dark>{d.overline}</Overline>
            </div>
          </Reveal>
          <h2 className="font-serif font-light leading-[1.02] text-5xl md:text-7xl mt-6">
            <LineReveal>{d.title}</LineReveal>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-white/75 text-lg font-light leading-relaxed">{d.body}</p>
          </Reveal>
          <Reveal delay={0.25}>
            <button onClick={() => navigate("/produkt/defense-components")}
              data-testid="defense-read-more-button"
              className="btn-line group mt-10 border border-white/40 px-9 py-4 text-[12px] uppercase tracking-[0.22em]">
              <span className="group-hover:text-white transition-colors duration-300">{d.cta || t.cta.contactUs}</span>
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Defense;
